module.exports = __webpack_public_path__ + "img/n-main.3dabaa23.jpg";